var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20454 3H10.7955C11.6741 3 12.3864 3.67157 12.3864 4.5C12.3864 5.44801 13.4007 6.05074 14.2333 5.59748L14.3179 5.55145C15.0788 5.13723 16.0518 5.38305 16.4911 6.10049L17.2866 7.39952C17.7259 8.11696 17.4652 9.03435 16.7043 9.44856C15.8712 9.90203 15.8712 11.098 16.7043 11.5514C17.4652 11.9657 17.7259 12.883 17.2866 13.6005L16.4911 14.8995C16.0518 15.617 15.0788 15.8628 14.3179 15.4486L14.2333 15.4025C13.4007 14.9493 12.3864 15.552 12.3864 16.5C12.3864 17.3284 11.6741 18 10.7955 18H9.20454C8.3259 18 7.61363 17.3284 7.61363 16.5C7.61363 15.552 6.5993 14.9493 5.76667 15.4025L5.6821 15.4486C4.92117 15.8628 3.94818 15.617 3.50887 14.8995L2.71341 13.6005C2.27409 12.883 2.5348 11.9657 3.29572 11.5514C4.12876 11.098 4.12876 9.90202 3.29572 9.44855C2.5348 9.03434 2.27409 8.11695 2.71341 7.39951L3.50887 6.10048C3.94819 5.38304 4.92117 5.13722 5.6821 5.55144L5.76667 5.59747C6.5993 6.05073 7.61363 5.44801 7.61363 4.5C7.61363 3.67157 8.3259 3 9.20454 3ZM10 13C11.3807 13 12.5 11.8807 12.5 10.5C12.5 9.11929 11.3807 8 10 8C8.6193 8 7.50001 9.11929 7.50001 10.5C7.50001 11.8807 8.6193 13 10 13Z",
    fill: "url(#paint0_linear_403_1925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_1925",
    x1: 7.375,
    y1: 18,
    x2: 7.375,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DB1E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillSetting);
export default __webpack_public_path__ + "static/media/fill-setting.526a0ea0e4e29aa4b3e10e49db5ac160.svg";
export { ForwardRef as ReactComponent };